import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.NetSuiteVendorSubsidiaryList', {
    subsidiaryColumnName: 'Subsidiary',
    creditLimitColumnName: 'Credit limit',
    taxCodeColumnName: 'Tax code',
});
